import React from "react";
import { Controller, Control, UseFormSetValue } from "react-hook-form";
import ApiSelect from "../../../components/ApiSelect";
import { ProductFormValues } from "../../../../types/api/product";

interface LocationTabProps {
  control: Control<ProductFormValues>;
  setValue: UseFormSetValue<ProductFormValues>;
  countriesData: any;
  countryOptions?: any[];
  refetchCountry: (query: any) => void;
  statesData: any;
  stateOptions?: any[];
  refetchState: (query: any) => void;
  citiesData: any;
  cityOptions?: any[];
  refetchCity: (query: any) => void;
  watchCountryId: string;
  watchStateId: string;
}

export const LocationTab: React.FC<LocationTabProps> = ({
  control,
  setValue,
  countriesData,
  countryOptions,
  refetchCountry,
  statesData,
  stateOptions,
  refetchState,
  citiesData,
  cityOptions,
  refetchCity,
  watchCountryId,
  watchStateId,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <Controller
        name="location.countryId"
        control={control}
        render={({ field }) => (
          <div>
            <label className="block text-sm font-medium mb-1">Country</label>
            <ApiSelect
              {...field}
              className="w-full"
              placeholder="Select Country"
              options={
                countryOptions ||
                countriesData?.data?.map((item: any) => ({
                  label: item.name,
                  value: item._id,
                }))
              }
              onChange={(val) => {
                field.onChange(val);
                setValue("location.stateId", undefined as any);
                setValue("location.cityId", undefined as any);
              }}
              refetchWithQuery={refetchCountry}
              baseQuery={{ limit: 100, page: 1 }}
            />
          </div>
        )}
      />
      <Controller
        name="location.stateId"
        control={control}
        render={({ field }) => (
          <div>
            <label className="block text-sm font-medium mb-1">
              State / Province
            </label>
            <ApiSelect
              {...field}
              className="w-full"
              placeholder="Select State"
              options={
                stateOptions ||
                statesData?.data?.map((item: any) => ({
                  label: item.name,
                  value: item._id,
                }))
              }
              disabled={!watchCountryId}
              onChange={(val) => {
                field.onChange(val);
                setValue("location.cityId", undefined as any);
              }}
              refetchWithQuery={refetchState}
              baseQuery={{ limit: 100, page: 1, countryId: watchCountryId }}
            />
          </div>
        )}
      />
      <Controller
        name="location.cityId"
        control={control}
        render={({ field }) => (
          <div>
            <label className="block text-sm font-medium mb-1">City</label>
            <ApiSelect
              {...field}
              className="w-full"
              placeholder="Select City"
              options={
                cityOptions ||
                citiesData?.data?.map((item: any) => ({
                  label: item.name,
                  value: item._id,
                }))
              }
              disabled={!watchStateId}
              onChange={(val) => field.onChange(val)}
              refetchWithQuery={refetchCity}
              baseQuery={{
                limit: 100,
                page: 1,
                countryId: watchCountryId,
                stateId: watchStateId,
              }}
            />
          </div>
        )}
      />
    </div>
  );
};
